// ABOUTME: Loading placeholder shown while a federated module bundle is fetched
// ABOUTME: Rendered by ModuleHost during the react-query pending state

export function ModuleSkeleton() {
  return (
    <output
      className="flex h-full items-center justify-center text-slate-400"
      aria-label="Loading module"
    >
      <span className="animate-pulse text-sm">Loading…</span>
    </output>
  );
}
